<ng-container>
  @if (buttonType() === 'modal-exit') {
    <button
      class="btn-close"
      [ngClass]="{'modal-exit': buttonType() === 'modal-exit'}"
      (click)="close()">
      <span>
        Close
      </span>
      <lib-icon [icon]="closeIcon" class="icon"></lib-icon>
    </button>
  }

  @if (buttonType() === 'notifaction-modal-exit') {
    <button
      class="btn-notifaction-close"
      [ngClass]="{'notifaction-exit': buttonType() === 'notifaction-exit'}"
      (click)="close()">
      <lib-icon [icon]="closeIcon" class="icon"></lib-icon>
    </button>
  }

  @if (buttonType() === 'snackbar-exit') {
    <button
      class="btn-close"
      (click)="closeSnackbar()"
      >
      <lib-icon [icon]="closeIcon" class="icon"></lib-icon>
    </button>
  }
</ng-container>


